<template>
    <div class="course-management">
        <!-- 课程表单 -->
        <el-dialog
            :visible.sync="dialog.visible"
            @close="handleCancel()"
            :close-on-click-modal="false"
            :custom-class="'course-dialog'"
            :width="!dialog.next ? '30%' : '40%'"
            :show-close="!dialog.next">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                {{dialog.title}}
            </div>
            <div class="course-panel" :class="{'next': dialog.next}">
                <el-form :model="dialog.content" ref="formContent" label-width="112px" :style="{'height': dialog.next ? '0rem' : 'inherit'}">
                    <el-form-item label="课程封面图: " prop="coverUrl">
                        <el-upload
                            :action="imageUploadUrl"
                            :headers="{'X-token': token}"
                            :show-file-list="false"
                            :on-success="handleUploadSuccess">
                            <el-button type="primary" size="small">
                                <i class="el-icon-plus"></i>
                                选择图片
                            </el-button>
                        </el-upload>
                        <img :style="{
                            'width': '100%'
                        }" v-if="dialog.content.coverUrl != ''" :src="'https://www.7amdancestudio.cn/image/' + dialog.content.coverUrl">
                    </el-form-item>
                    <el-form-item label="课程名称: " prop="courseName">
                        <el-input v-model="dialog.content.courseName" placeholder="请输入课程名称"></el-input>
                    </el-form-item>
                    <el-form-item label="课程老师" prop="teacher">
                        <el-select v-model="courseIntroduce.teacher" 
                            :popper-append-to-body="false"
                            placeholder="请选择课程教师" 
                            popper-class="teacher-selector"
                            @change="handleTeacherChange">
                            <el-option v-for="teacher in teacherList" 
                                :key="teacher.teacher" 
                                :label="teacher.teacher" 
                                :value="teacher.teacher">
                                <p class="title">{{ teacher.teacher }}</p>
                                <p class="introduce">{{ teacher.teacherIntroduce }}</p>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="报名截止: " v-if="dialog.type === 'insert'">
                        <el-select v-model="dialog.deadlineDiff" 
                            :popper-append-to-body="false"
                            placeholder="请选择报名截止时间" 
                            @change="handleTeacherChange">
                            <el-option v-for="diff in deadlineList" 
                                :key="diff.value" 
                                :label="diff.name" 
                                :value="diff.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="课程内容: ">
                        <el-input v-model="courseIntroduce.courseDetail" placeholder="请输入课程内容"></el-input>
                    </el-form-item>
                    <el-form-item label="课程难度: ">
                        <el-select v-model="courseIntroduce.courseDegree" placeholder="请选择课程难度">
                            <el-option v-for="(item, i) in degreeSelector" :key="'degree' + i" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="课程成课人数: " prop="beginNum" v-if="dialog.type ==='insert'">
                        <el-input type="number" :min="2" v-model="dialog.content.beginNum" placeholder="请输入课程成课人数"></el-input>
                    </el-form-item>
                    <el-form-item label="课程最大人数: " prop="maximum" v-if="dialog.type ==='insert'">
                        <el-input type="number" v-model="dialog.content.maximum" placeholder="请输入课程最大人数"></el-input>
                    </el-form-item>
                    <el-form-item label="客服微信: " prop="customerWx">
                        <el-input v-model="dialog.content.customerWx" placeholder="请输入客服微信"></el-input>
                    </el-form-item>
                </el-form>
                <el-form :model="dialog.slotContent" ref="formContent" label-width="112px" :style="{'display': 'flex'}">
                    <div class="classroom-list">
                        <div v-for="classroom in dialog.classroomList" 
                            :key="classroom.classroomId" 
                            class="item"
                            :class="{'selected': classroom.value === dialog.slotContent.classroomId}"
                            @click="handleClassroomCheck(classroom.value)">
                            {{ classroom.name }}
                        </div>
                    </div>
                    <div class="slot-wrapper" :style="{'display': 'flex', 'flex-direction': 'column'}">
                        <span>
                            日期：
                            <el-date-picker
                                v-model="dialog.slotContent.courseDate"
                                type="date"
                                :clearable="false"
                                value-format="yyyy-MM-dd"
                                @change="handleDateChange()"
                                placeholder="选择日期"
                                :style="{'margin-bottom': '1.2rem'}">
                            </el-date-picker>
                        </span>
                        <!-- <el-form-item label="日期: ">
                        </el-form-item> -->
                        <div class="slot-panel">
                            <div class="slot-item" :class="{
                                'disabled': slot.status === 2,
                                'selected': slot.selected
                            }" v-for="slot in dialog.slotList" :key="slot.slotId + slot.selected" @click="checkSlot(slot)">
                                <p class="day">{{ slot.startTime }} - {{ slot.endTime }}</p>
                                <p class="status-info" v-if="slot.status === 3">{{ slot.statusInfo }}</p>
                                <p class="status-info" v-if="slot.status === 2">该时段不可选</p>
                                <p class="status-info" v-if="slot.status === 1">¥{{ slot.price / 100 }}</p>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer" v-if="!dialog.next">
                <el-button type="cancel" size="small" @click="handleCancel()">取消</el-button>
                <el-button type="primary" :loading="dialog.loading" size="small" @click="submit()">{{ dialog.loading ? '请求中...' : '确定' }}</el-button>
            </span>
            <span slot="footer" class="dialog-footer" v-else>
                <el-button type="primary" size="small" @click="confirmInsertCourse()">确定</el-button>
            </span>
        </el-dialog>
        <div class="el-card-title" v-if="pageCfg.storeId">
            <span>数据筛选</span>
        </div>
        <div class="filter-row" v-if="pageCfg.storeId">
            <div class="filter-item">
                <span class="filter-title">所属门店： </span>
                <el-select clearable v-model="pageCfg.storeId" @change="handleStoreChange" placeholder="请选择所属门店" :disabled="$store.getters.getUserInfo.storeId != undefined">
                    <el-option v-for="(item, i) in storeList" :key="i" :label="item.name" :value="item.value"></el-option>
                </el-select> 
            </div>
        </div>
        
        <div class="el-card-title">
            <span>课程列表</span>
            <div :style="{ display: 'flex' }">
                <el-input
                    clearable
                    type="text"
                    class="table-search"
                    v-model="pageCfg.courseName"
                    prefix-icon="el-icon-search"
                    placeholder="请输入课程名称"
                    @input="handleInput"
                ></el-input>

                <el-tooltip effect="dark" content="新增课程" placement="top">
                    <el-button type="text" @click="handleCourseInsert">
                        <i class="mdi mdi-24px mdi-plus"></i>
                    </el-button>
                </el-tooltip>
                <!-- <el-tooltip effect="dark" content="新增课程" placement="top" v-if="!this.$store.getters.getUserInfo.storeId">
                    <el-button type="text" @click="handleCourseInsert">
                        <i class="mdi mdi-24px mdi-plus"></i>
                    </el-button>
                </el-tooltip> -->
            </div>
        </div>
        <custom-table :table="tableData" :options="{
            maxHeight: 760
        }">
            <template slot="coverUrl" slot-scope="item">
                <a :href="'https://www.7amdancestudio.cn/image/' + item.data.row.coverUrl" target="blank">查看图片</a>
                <!-- <img v-if="item.data.row.coverUrl" 
                    :src="'https://www.7amdancestudio.cn/image/' + item.data.row.coverUrl"
                    :style="{'width': '20rem'}">
                <span v-else>-</span> -->
            </template>
            <template slot="operation" slot-scope="item">
                <el-button type="text" size="small" :disabled="item.data.row.peopleNum > 0" @click="handleCourseEdit(item.data.row)">编辑</el-button>
            </template>
        </custom-table>
        <el-pagination
            :current-page="pageCfg.currentPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="pageCfg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.pageTotal"
            @current-change="handlePageChange"
            @size-change="handleSizeChange">
        </el-pagination>
    </div>
</template> 

<script>
import { ClassroomManagementApi } from '../http/classroomManagement/classroomManagement';
import { CourseManagementApi } from '../http/courseManagement/courseManagement';
import { CommonApi } from '../http/common';
import { FileApi } from '../http/file';
import { Utils } from '../utils/index';
import CustomTable from '../components/customTable.vue';

let timer = null;
export default {
    name: "course-management",
    components: {
        CustomTable
    },
    data(){
        return {
            tableData: { 
                data: [],
                columns: [],
                tableLoading: false,
                pageTotal: 0
            },
            pageCfg: {
                currentPage: 1,
                pageSize: 15,
                courseName: "",
                storeId: ""
            },
            deadlineList: [
                {
                    name: "12小时",
                    value: 43200000
                },
                {
                    name: "9小时",
                    value: 32400000
                },
                {
                    name: "6小时",
                    value: 21600000
                },
                {
                    name: "3小时",
                    value: 10800000
                },
            ],
            storeList: [],
            // courseId: "",
            dialog: {
                title: "",              // 面板标题
                visible: false,         // 面板显示控制字段
                type: "",               // 新增课程/编辑课程标识
                loading: false,         // 新增课程的加载标识
                next: false,             // 标识是否为下一步，选择课程时间
                classroomList: [],      // 教室列表
                slotList: [],           // 时段列表
                deadlineDiff: "",
                content: {
                    storeId: "",
                    courseName: "",
                    coverUrl: "",
                    beginNum: "2",
                    // price: "8000",
                    deadline: "2023-01-01 00:00:00",
                    maximum: "4",
                    customerWx: "",
                    introduce: ""
                    // reorder: null
                },
                slotContent: {
                    classroomId: "",
                    courseDate: "",
                    courseId: "",
                    deadline: "",
                    slotIdList: "",
                    storeId: "",
                    week: ""
                }
            },
            dialogCourse: {
                visible: false,
                content: {}
            },
            // 课程等级下拉
            degreeSelector: [
                {
                    name: "基础",
                    value: "基础"
                },
                {
                    name: "提高",
                    value: "提高"
                }
            ],

            // 微信下拉
            wxSelector: [
                {
                    name: "博物馆店微信",
                    value: "sevenamM0001",
                    store: []
                },
                {
                    name: "哈西店微信, 哈西店NO.2（大门密码10个8）微信",
                    value: "sevenamM0002",
                    store: ['b1a55075a0b9b1b91eb40d2386487ae7', '836ac9da48ce6fa76542e09991cf156c']
                },
                {
                    name: "平房店微信",
                    value: "kefu7am",
                    store: []
                },
            ],

            // 课程介绍
            courseIntroduce: {
                teacher: "",
                teacherIntroduce: "",
                times: "",
                courseDetail: "",
                courseDegree: ""
            },

            // 教师列表（原始数据）
            teacherCache: [                
                {
                    "storeList": [],
                    "store": "博物馆店",
                    "teacher": "NING",
                    "teacherIntroduce": "舞龄6年教龄5年；联合利华上海总部内部培训老师；东方卫视伴舞；曾在上海swag团体kencil box；进修于5km gh5",
                    "teachYear": 2018,
                    "dancingYear": 2017
                },
                {
                    "storeList": [],
                    "store": "博物馆店",
                    "teacher": "XIAN",
                    "teacherIntroduce": "舞龄6年教龄4年；丰富舞台经验；辽宁传媒学院舞社前社长；辽宁省高校街舞联谊大赛亚军；沈阳文体工商协会授权培养教师资格认证；中国舞蹈家协会综合教师三级；mall star 齐舞大赛团队第四名；WDG全国街舞齐舞大赛黑龙江省冠军；WDG全国大赛郑州赛区前十；省文联优秀街舞展演教师",
                    "teachYear": 2020,
                    "dancingYear": 2018
                },
                {
                    "storeList": ['b1a55075a0b9b1b91eb40d2386487ae7', '836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店,哈西店NO.2（大门密码10个8）",
                    "teacher": "TAO",
                    "teacherIntroduce": "舞龄7年教龄5年；多次个人及团队编排经验；多次与国内外知名舞者学习；作为舞蹈演员参加春晚节目录制；宝石GEM哈尔滨特约伴舞；dance now齐舞比赛亚军",
                    "teachYear": 2018,
                    "dancingYear": 2016
                },
                {
                    "storeList": ['b1a55075a0b9b1b91eb40d2386487ae7', '836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店,平房店,哈西店NO.2（大门密码10个8）",
                    "teacher": "Jennie",
                    "teacherIntroduce": "舞龄9年，教龄5年；擅长舞种：K-pop、power jazz、hiphop；多次团队及个人编舞经验；多次与国内外知名舞者学习；2016年在北京龙舞天团进修学习；多次和黑龙江广播电台合作春晚伴舞；2017年中俄边境大型晚会舞蹈编导；2018年，跟随韩国国际知名团队工作室Soul Dance老师兼队长Girin Jang与多名优秀舞者进修学习；高校街舞比赛团队冠军及比赛评委；2019年，中国舞蹈家协会会员；中国舞蹈家协会教师资格认证；明星伴舞，宝石老舅演唱会嘉宾；2021年Dance Now齐舞比赛亚军团队及编舞师",
                    "teachYear": 2018,
                    "dancingYear": 2014
                },
                {
                    "storeList": ['b1a55075a0b9b1b91eb40d2386487ae7', '836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店,哈西店NO.2（大门密码10个8）",
                    "teacher": "QingTing",
                    "teacherIntroduce": "舞龄5年教龄2年；多次参加国内外大师课进修；中韩文化交流会阿里郎节韩舞大赛冠军团队成员；多次担任kpop音乐节开场嘉宾；多次出席各类演出活动及拍摄工作。",
                    "teachYear": 2018,
                    "dancingYear": 2014
                },
                {
                    "storeList": ['836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店",
                    "teacher": "QIANG",
                    "teacherIntroduce": "舞龄6年；这就是街舞2哈尔滨见面会特邀嘉宾；省文联青年舞团进高校专场演出嘉宾；舞蹈风暴大赛 ”十佳舞者；TNT街舞队往届团长；哈尔滨之夏音乐晚会演出节目指导；DANCE NOW vol3齐舞挑战赛亚军；曾为明星姜鹏伴舞；曾被邀出演省电视台节目开场舞",
                    "teachYear": null,
                    "dancingYear": 2017
                },
                // {
                //     "store": "哈西店",
                //     "teacher": "QianQian",
                //     "teacherIntroduce": "舞龄14年，教龄5年；有多年教授kpop/爵士经验；参与CCTV3《街舞英雄》录制；曾为飞儿、阿里郎伴舞；多次参与各大演出，具有丰富的舞台经验；教学细致，通俗易懂，教学风格幽默风趣",
                //     "teachYear": 2018,
                //     "dancingYear": 2009
                // },
                {
                    "storeList": ['836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店,平房店",
                    "teacher": "ZIHENG",
                    "teacherIntroduce": "舞龄9年教龄6年；擅长风格：hip-hop、breaking；跟随韩国国际知名团队工作室，Soul Dance老师兼队长Girin Jang与多名优秀舞者进修学习；跟随日本En街舞工作室国际知名教师Miqael与多名优秀舞者进修学习；黑龙江省春节联欢晚会 、冰雪大世界 、跨年晚会现场 、参演演员 ；作为舞蹈演员，参与省运动会闭幕式进行现场直播演出；作为舞蹈演员参与祖国70周年庆典进行演出；团体比赛 breaking团体比赛第一",
                    "teachYear": 2018,
                    "dancingYear": 2017
                },
                {
                    "storeList": ['836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店",
                    "teacher": "阿柚",
                    "teacherIntroduce": "舞龄8年教龄6年；北京卫视春晚伴舞；WOD北京赛区团体季军；携程北京总部年会指导教师；我是歌王伴舞；进修于日本EN",
                    "teachYear": 2017,
                    "dancingYear": 2015
                },
                {
                    "storeList": ['b1a55075a0b9b1b91eb40d2386487ae7'],
                    "store": "哈西店NO.2（大门密码10个8）",
                    "teacher": "SUNNY",
                    "teacherIntroduce": "舞龄5年教龄2年；多次参加国内外大师课进修；kpop翻跳大赛冠军团队成员；曾多次出席各种演出活动以及拍摄活动",
                    "teachYear": 2017,
                    "dancingYear": 2015
                },
                {
                    "storeList": ['b1a55075a0b9b1b91eb40d2386487ae7'],
                    "store": "哈西店NO.2（大门密码10个8）",
                    "teacher": "ZIYU",
                    "teacherIntroduce": "舞龄6年教龄3年。国内知名明星特约伴舞；二手玫瑰演唱会开场嘉宾；曾多次参与省台春晚录制；中韩文化交流会阿里郎节舞蹈大赛冠军；有丰富的舞蹈及舞蹈编导经验",
                    "teachYear": 2017,
                    "dancingYear": 2015
                },
                {
                    "storeList": [],
                    "store": "平房店",
                    "teacher": "小权",
                    "teacherIntroduce": "舞龄5年；擅长风格：K-pop、Jazz Funk、Girl's Hiphop、Swag；中国舞蹈家协会爵士舞专业教师资格认证；曾担任哈尔滨学院2020-2022年街舞社社长曾担任哈尔滨学院OBcrew爵士队长；2018年赴韩国1millon舞蹈工作室学习。向当红老师Mayjlee mina老师等学习；大学生hiphop之夜freestyle 四强；2019年赴韩国just jerk舞蹈工作室学习。向badalee jho老师等学习",
                    "teachYear": 2017,
                    "dancingYear": 2015
                },
                {
                    "storeList": ['b1a55075a0b9b1b91eb40d2386487ae7', '836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店,哈西店NO.2（大门密码10个8）,平房店",
                    "teacher": "木木",
                    "teacherIntroduce": "舞龄6年教龄2年；擅长风格：kpop、jazz、urban；2018年校社团社长 kpop队队长；2020年黑龙江电视台中秋晚会分会场伴舞录制；2021年校园街舞比赛冠军成员；2022年黑龙江齐舞大赛亚军小组成员；经常组织随舞和路演",
                    "teachYear": 2017,
                    "dancingYear": 2015
                },
                {
                    "storeList": ['836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店",
                    "teacher": "CC",
                    "teacherIntroduce": "舞龄5年教龄3年；擅长风格：power、jazz、heels；2020年高校舞蹈大赛季军；2022年高校舞蹈大赛冠军；2023年零上舞度年度公演邀请嘉宾；ALL DANCE街舞俱乐部年度公演邀请嘉宾；7月份进修于大蜜舞舍",
                    "teachYear": 2021,
                    "dancingYear": 2019
                },
                {
                    "storeList": ['b1a55075a0b9b1b91eb40d2386487ae7'],
                    "store": "哈西店NO.2（大门密码10个8）",
                    "teacher": "念念",
                    "teacherIntroduce": "擅长舞种：Jazz、Hiphop；舞龄七年 教龄三年；获得中国舞蹈家协会十二级证书；2024年带队获全国青少年街舞公开赛黑龙江赛区亚军",
                    "teachYear": 2021,
                    "dancingYear": 2019
                },
                {
                    "storeList": ['b1a55075a0b9b1b91eb40d2386487ae7', '836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店,哈西店NO.2（大门密码10个8）",
                    "teacher": "瑶瑶",
                    "teacherIntroduce": "擅长舞种：Jazz、Kpop；舞龄三年 教龄两年；获得中国舞蹈家协会十二级证书；25年初在哈尔滨市任教；24年在学校舞蹈大赛两人组获得一等奖；带领自己团队多次参加舞蹈比赛；获得优秀名次",
                    "teachYear": 2021,
                    "dancingYear": 2019
                },
                {
                    "storeList": ['b1a55075a0b9b1b91eb40d2386487ae7', '836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店,哈西店NO.2（大门密码10个8）",
                    "teacher": "YAYA",
                    "teacherIntroduce": "擅长舞种：Jazz、Urban、k-pop、抒情编舞、Hiphop；曾获得中国街舞联赛校园赛团体赛第三名；中国舞蹈家协会教师资格证书",
                    "teachYear": 2021,
                    "dancingYear": 2019
                },
                {
                    "storeList": ['b1a55075a0b9b1b91eb40d2386487ae7', '836ac9da48ce6fa76542e09991cf156c'],
                    "store": "哈西店,哈西店NO.2（大门密码10个8）",
                    "teacher": "佳一",
                    "teacherIntroduce": "擅长舞种：Jazz、waacking；TQODwaacking青岛赛区十六强；黑龙江省街舞锦标赛四强；TQODwaacking哈尔滨赛区十六强",
                    "teachYear": 2021,
                    "dancingYear": 2019
                },
            ],
            teacherList: [],
            imageUploadUrl: FileApi.imageUpload,
            // 认证token
            token: "",
        }
    },
    mounted(){
        this.dialog.slotContent.courseDate = Utils.getSystemFullTime().date;
        this.token = localStorage.getItem('authToken');
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.dialog.content.storeId = userInfo.storeId ? userInfo.storeId: "";
        this.dialog.slotContent.storeId = userInfo.storeId ? userInfo.storeId: "";
        this.pageCfg.storeId = userInfo.storeId ? userInfo.storeId: "";
        this.getStoreList();
    },
    methods: {
        // 获取门店列表
        getStoreList(){
            CommonApi.getStoreSelectorList().then(res => {
                this.storeList = res;
                if(!this.pageCfg.storeId){
                    this.pageCfg.storeId = this.storeList[0].value;
                    this.dialog.content.storeId = this.storeList[0].value;
                    this.dialog.slotContent.storeId = this.storeList[0].value;
                }
                this.getCourseList();
                this.getClassroomList();
            })
        },

        // 获取教室列表（用于设置课程时段）
        getClassroomList(){
            ClassroomManagementApi.getClassroomList({
                storeId: this.pageCfg.storeId
            }).then(res => {
                this.dialog.classroomList = res.data.map(item => {
                    return {
                        name: item.classroomName,
                        value: item.classroomId
                    }
                });
            })
        },
        // 获取教室时段列表
        getClassroomSlotList(){
            ClassroomManagementApi.getClassroomSlotList({
                classroomId: this.dialog.slotContent.classroomId,
                searchDay: this.dialog.slotContent.courseDate
            }).then(res => {
                this.dialog.slotList = [...res];
            })
        },
        // 获取课程列表
        getCourseList(){
            this.tableData.tableLoading = true;
            CourseManagementApi.getCourseList(this.pageCfg).then(res => {
                this.tableData.tableLoading = false;
                Object.assign(this.tableData, res);
            });
        },

        // 弹框关闭控制方法
        handleCancel(){
            this.dialog.visible = false;
            this.dialog.next = false;
            this.dialog.deadlineDiff = 43200000;
            for(let key in this.dialog.content){
                if(key === 'deadline')
                    this.dialog.content[key] = "2023-01-01 00:00:00";
                else
                    this.dialog.content[key] = "";
            }
            for(let key in this.courseIntroduce){
                this.courseIntroduce[key] = "";
            }
            for(let key in this.dialog.slotContent){
                this.dialog.slotContent[key] = "";
            }
        },
        handleCourseEdit(row){
            this.dialog.visible = true;
            this.dialog.title = "编辑课程";
            this.dialog.type = 'edit';
            this.courseId = row.courseId;
            this.teacherList = [];
            this.dialog.content.beginNum = 2;
            this.initNum(this.pageCfg.storeId);
            
            for(let key in this.dialog.content){
                this.dialog.content[key] = row[key];
            }
            let index = 0;

            // 
            for(let key in this.courseIntroduce){
                this.courseIntroduce[key] = this.dialog.content.introduce.split(';')[index].split('：')[1];
                index++;
            }
            // 初始化教师下拉
            if(this.pageCfg.storeId){
                const storeName = this.storeList.find(item => { return item.value === this.pageCfg.storeId}).name;
                this.teacherCache.forEach(item => {
                    if(item.storeList.indexOf(this.pageCfg.storeId) >= 0){
                        this.teacherList.push(item);
                    }
                })
                if(storeName.includes('哈西店NO.2（大门密码10个8）')){
                    this.dialog.deadlineDiff = 21600000;
                } else{
                    this.dialog.deadlineDiff = 43200000;
                }
            }
            
        },
        handleCourseInsert(){
            this.dialog.visible = true;
            this.dialog.title = "新增课程";
            this.dialog.type = 'insert';
            this.dialog.next = false;
            this.teacherList = [];
            this.dialog.slotContent.classroomId = this.dialog.classroomList[0].value;
            this.dialog.content.beginNum = 2;
            this.initNum(this.pageCfg.storeId);
            
            // 初始化微信
            // const store = this.storeList.find(item => { return item.value === this.pageCfg.storeId});
            const wx = this.wxSelector.find(item => { return item.store.indexOf(this.pageCfg.storeId) >= 0 });
            this.dialog.content.customerWx = wx.value;

            // 初始化课程难度
            this.courseIntroduce.courseDegree = "基础";

            // 初始化教师下拉
            if(this.pageCfg.storeId){
                const storeName = this.storeList.find(item => { return item.value === this.pageCfg.storeId}).name;
                this.teacherCache.forEach(item => {
                    if(item.storeList.indexOf(this.pageCfg.storeId) >= 0){
                        this.teacherList.push(item);
                    }
                })
                // this.teacherList = this.teacherCache.filter(item => { 
                //     return item.storeList.indexOf(this.pageCfg.storeId) >= 0;
                // });
                if(storeName.includes('哈西店NO.2（大门密码10个8）')){
                    this.dialog.deadlineDiff = 21600000;
                } else{
                    this.dialog.deadlineDiff = 43200000;
                }
            }
        },
        handleUploadSuccess(res){
            this.dialog.content.coverUrl = res.content;
        },
        submit(){
            this.initIntroduce();
            
            const record = {
                ...this.dialog.content
            }
            if(this.dialog.type === 'insert'){
                record.price = 6800;
                record.reorder = this.tableData.pageTotal + 1;
                record.storeId = this.pageCfg.storeId;
                this.dialog.slotContent.storeId = this.pageCfg.storeId;
                if(!record.coverUrl){
                    this.$notify.error({ title: '课程封面不能为空' });
                    return false;
                }
                if(!record.courseName){
                    this.$notify.error({ title: '课程名称不能为空' });
                    return false;
                }
                if(!this.courseIntroduce.teacher){
                    this.$notify.error({ title: '请选择课程教师' });
                    return false;
                }
                if(!this.courseIntroduce.courseDetail){
                    this.$notify.error({ title: '课程内容不能为空' });
                    return false;
                }
            }
            if(this.dialog.type === 'edit'){
                record.courseId = this.courseId;
            }
            this.dialog.loading = true;
            CourseManagementApi[this.dialog.type === 'insert' ? 'insertCourse' : 'updateCourse'](record).then(res => {
                if(res.data.status === 200){
                    this.dialog.loading = false;
                    if(this.dialog.type === 'insert'){
                        this.dialog.next = true;
                        this.dialog.slotContent.courseId = res.data.content.courseId;
                        this.getClassroomSlotList();
                    } else{
                        this.$notify.success({ title: '编辑课程成功' });
                        this.handleCancel();
                        this.getCourseList();
                    }
                } else{
                    this.$notify.error({ title: res.data.message });
                    this.dialog.loading = false;
                }
            })
        },
        confirmInsertCourse(){
            if(!this.dialog.slotContent.slotIdList){
                this.$notify.error({ title: "请选择课程时段" });
                return false;
            }
            const param = this.dialog.slotContent;  // 初始化提交参数
            // 拿到时段id的第一个用来找到报名截止时间
            const id = this.dialog.slotContent.slotIdList.split(',')[0]; 
            const time = this.dialog.slotList.find(item => { return item.slotId === id}).startTime + ":00";

            const courseDate = this.dialog.slotContent.courseDate + ' ' + time;
            const deadline = Utils.getSystemFullTime(new Date(courseDate).getTime() - this.dialog.deadlineDiff);
            param.deadline = deadline.date + ' ' + deadline.time + ':00';
            param.introduce = this.dialog.content.introduce;


            const slotName = this.dialog.slotList
                .filter(item => { return item.selected === true })
                .map(item => { return `${item.startTime}-${item.endTime}` })
                .join(',');
            this.dialog.loading = true;
            this.$confirm(`确定将本课程的课程时间设置为：${slotName}吗？`, '时间设定', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                ClassroomManagementApi.editClassroomSlot(param).then(res => {
                    if(res.data.status === 200){
                        this.$notify.success({ title: "新增课程成功" });
                        this.slotList = [];
                        this.handleCancel();
                        this.getCourseList();
                    }
                    this.dialog.loading = false;
                });
            }).catch(() => {
                this.$notify.warning({ title: "已取消设定" });
                this.dialog.loading = false;
            })
        },
        handlePageChange(page){
            this.pageCfg.currentPage = page;
            this.getCourseList();
        },
        handleSizeChange(size){
            this.pageCfg.pageSize = size;
            this.getCourseList();
        },
        handleInput(){
            if(timer){
                clearTimeout(timer);
                timer = null;
            }
            timer = setTimeout(() => {
                this.getCourseList();
                timer = null;
                clearTimeout(timer);
            }, 500);
        },
        handleTeacherChange(teacher){
            // this.courseIntroduce.teacher = teacher.teacher;
            this.courseIntroduce.teacherIntroduce = this.teacherList.find(item => { return item.teacher === teacher}).teacherIntroduce;
        },
        handleStoreChange(value){
            this.initNum(value);
            this.getClassroomList();
            this.getCourseList();
        },
        initNum(value){            
            const name = this.storeList.find(item => {
                if(value === item.value){
                    return item;
                }
            }).name;

            this.dialog.content.beginNum = name.indexOf('哈西新店') >= 0 ? 3 : 2;
            this.dialog.content.maximum = name.indexOf('哈西新店') >= 0 ? 8 : 5;
        },
        initIntroduce(){
            let strArr = [];
            const map = {
                teacher: "舞蹈教师：",
                teacherIntroduce: "教师介绍：",
                times: "课程时长：",
                courseDetail: "课程内容：",
                courseDegree: "课程难度："
            }

            for(let key in this.courseIntroduce){
                if(this.courseIntroduce[key].indexOf(';') >= 0){
                    this.$notify.warning({ title: '编辑内容中不应包括英文的“;”请重新编辑'})
                    return false;
                } else{
                    if(this.dialog.type === 'insert' && key === 'times'){
                        let times = 0;
                        if(this.dialog.slotList.length > 0){
                            times = this.dialog.slotList.filter(item => { return item.selected === true}).length;
                        }
                        strArr.push(map[key] + times + '小时');
                    }
                    else
                        strArr.push(map[key] + this.courseIntroduce[key]);
                }
            }

            this.dialog.content.introduce = strArr.join(';');
        },
        handleClassroomCheck(classroomId){
            this.dialog.slotContent.classroomId = classroomId;
            this.getClassroomSlotList();
        },
        handleDateChange(){
            this.dialog.slotContent.week = Utils.getSystemFullTime(this.dialog.slotContent.courseDate).week;
            this.dialog.slotContent.slotIdList = "";
            this.getClassroomSlotList();
        },
        checkSlot(slot){
            if(slot.status != 1){
                this.$notify.warning({title: "该时段不可选，请选择其他时段"});
                return false;
            }
            slot.selected = !slot.selected;
            const list = this.dialog.slotList
                .filter(item => { return item.selected === true })
                .map(item => { return item.slotId });
            this.dialog.slotContent.slotIdList = list.join(",");
            this.initIntroduce();
        }
    }
}
</script>

<style lang="less">
div.course-management{
    .teacher-selector{
        .el-select-dropdown__item{
            background: rgba(0, 138, 255, .05);
            margin: 1rem 1.2rem 1rem;
            padding: 1.2rem 1.6rem;
            border-radius: .6rem;
            white-space: initial;
            height: fit-content;
            width: 40rem;

            p{
                margin: 0;
            }
            p.title{
                color: #5473E8;
                font-weight: bold;
                font-size: 1.6rem;
            }
            p.introduce{
                line-height: 2.4rem;
            }
            &.hover{
                background: #5473E8;
                p{
                    font-weight: bold;
                    color:#fff;
                }
            }
        }
    }
    .course-panel{
        transition: .3s all;
        flex-wrap: nowrap;
        display: flex;
        .el-form{
            width: 100%;
            flex: none;
        }
        &.next{
            transform: translateX(calc(-100% - 2rem));
        }
    }
    .el-dialog__body{
        overflow: hidden;
        .classroom-list{
            flex-direction: column;
            padding-left: 2rem;
            display: flex;
            width: 22rem;
            .item{
                transition: .3s all ease;
                background: #eeeeee;
                border-radius: 0.8rem;
                padding: 1.2rem 2rem;
                margin-bottom: 1rem;
                font-weight: bolder;
                cursor: pointer;
                &.selected, &:hover{
                    background: #5473E8;
                    color: #fff;
                }
            }
        }
        .slot-wrapper{
            width: calc(100% - 22rem);
            flex-direction: column;
            margin-left: 2rem;
            display: flex;
        }
    }
}
</style>